import React, { useState } from "react";
import { Highlight, themes } from "prism-react-renderer";
import { Copy, Download } from "lucide-react";

export default function SyntaxCodeViewer({ code, filename, language, badge, onDownload }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div style={{ borderRadius: 12, overflow: "hidden", border: "1px solid #252a3d" }}>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "10px 16px", background: "#1c2030", borderBottom: "1px solid #252a3d",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: "0.82rem", fontFamily: "monospace", color: "#cbd5e1", fontWeight: 600 }}>
            {filename}
          </span>
          {badge && (
            <span style={{
              fontSize: "0.72rem", fontFamily: "monospace",
              padding: "2px 8px", background: "#2d3350",
              color: "#94a3b8", borderRadius: 4,
            }}>
              {badge}
            </span>
          )}
        </div>
        <div style={{ display: "flex", gap: 18 }}>
          <button
            onClick={handleCopy}
            style={{ background: "none", border: "none", cursor: "pointer",
              color: copied ? "#4ade80" : "#94a3b8", fontSize: "0.78rem",
              display: "flex", alignItems: "center", gap: 5 }}
          >
            <Copy size={12} /> {copied ? "Copied!" : "Copy"}
          </button>
          <button
            onClick={onDownload}
            style={{ background: "none", border: "none", cursor: "pointer",
              color: "#94a3b8", fontSize: "0.78rem",
              display: "flex", alignItems: "center", gap: 5 }}
          >
            <Download size={12} /> Download
          </button>
        </div>
      </div>

      <Highlight theme={themes.vsDark} code={code.trim()} language={language}>
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre
            className={className}
            style={{
              ...style,
              margin: 0, padding: "14px 0",
              maxHeight: 480, overflowY: "auto", overflowX: "auto",
              fontSize: "0.775rem", lineHeight: 1.65,
              background: "#141728",
            }}
          >
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line })} style={{ display: "flex" }}>
                <span style={{
                  display: "inline-block", width: 44, textAlign: "right",
                  paddingRight: 16, paddingLeft: 8,
                  color: "#3c435e", userSelect: "none",
                  fontSize: "0.72rem", flexShrink: 0,
                }}>
                  {i + 1}
                </span>
                <span style={{ paddingRight: 16 }}>
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token })} />
                  ))}
                </span>
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  );
}
